import { render } from "./BalAlert.vue?vue&type=template&id=bd1f5ac4&scoped=true&ts=true"
import script from "./BalAlert.vue?vue&type=script&lang=ts"
export * from "./BalAlert.vue?vue&type=script&lang=ts"

import "./BalAlert.vue?vue&type=style&index=0&id=bd1f5ac4&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1f5ac4"]])

export default __exports__